// extracted by mini-css-extract-plugin
module.exports = {"paperWidthFalse":"r18AlertDialog_paperWidthFalse__1yTdI","root":"r18AlertDialog_root__2gQIG"};